@if (visible()) {
@if (compact) {
<div class="info-banner info-banner--compact" role="note">
  <ion-icon [name]="icon" class="info-banner-icon" aria-hidden="true"></ion-icon>
  <span class="info-line"><b>{{ titleKey | translate }}.</b> {{ textKey | translate }}</span>
  <button class="close-btn" type="button" (click)="dismiss()" aria-label="Cerrar">
    <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
  </button>
</div>
} @else {
<div class="info-banner" role="note">
  <ion-icon [name]="icon" class="info-banner-icon"></ion-icon>
  <div class="info-content">
    <div class="info-title-row">
      <h3 class="info-title">
        {{ titleKey | translate }}
      </h3>
      <button
        class="close-btn"
        type="button"
        (click)="dismiss()"
        aria-label="Cerrar"
      >
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </div>
    <p class="info-text">
      {{ textKey | translate }}
    </p>
  </div>
</div>
}
}
